const Health = ({ className = "", color }: { className?: string; color: string }): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer2"
      d="M6.775 7.821l25-5.769a1 1 0 0 1 .449 0l25 5.77A1 1 0 0 1 58 8.8v15.265A41.975 41.975 0 0 1 31.994 62 41.97 41.97 0 0 1 6 24.065V8.8a1 1 0 0 1 .775-.979z"
      fill={color}
    ></path>
    <path
      data-name="layer1"
      d="M39 18a7.549 7.549 0 0 0-7 4.814A7.549 7.549 0 0 0 25 18a7.113 7.113 0 0 0-7 7.222C18 31.481 23.133 37.74 32 44c8.867-6.26 14-12.519 14-18.778A7.113 7.113 0 0 0 39 18z"
      fill="white"
    ></path>
    <path
      data-name="opacity"
      d="M31.775 2.052l-25 5.77A1 1 0 0 0 6 8.8v15.265A41.97 41.97 0 0 0 31.994 62H32V2.052a1.016 1.016 0 0 0-.225 0z"
      fill="#000064"
      opacity=".16"
    ></path>
  </svg>
);

export default Health;
